"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var HeadCell_1 = __importDefault(require("./HeadCell"));

exports.default = HeadCell_1.default;